/** Shopify CDN: Minification failed

Line 46:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 48:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 48:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 50:36 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 63:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 69:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 69:18 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 71:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 3 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 33:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 35:36 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 48:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 54:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 54:18 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 56:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 3 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 18:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 18:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 20:36 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 33:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 39:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 39:18 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 41:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 3 more hidden warnings

**/
(async () => {
    const { Core } = await importModule('Core');
    const { $replaceContent, $toggleDisplay } = await importModule('Utils');

    customElements.define('x-cart', class extends Core {
        elements = {
            itemsContainer: '[data-cart-items-container]',
            emptyMsg: '[data-cart-empty]',
            items: '[data-cart-items]',
            subtotalBlock: '[data-cart-subtotal-block]',
            freeShippingBlock: '[data-cart-free-shipping-block]'
        }
        
        subscriptions = {
            'cart:update': '_onUpdate',
        }

        async render() {
            await customElements.whenDefined('cart-provider');
            this.publish('cart:add-feature', { feature: 'cart' });
            this.subscribe('cart:update', { global: true });
        };

        _onUpdate({ cart }) {
            if (!cart) return;
            const hasCartItems = cart.getCount() > 0;
            this._toggleView(hasCartItems);
            hasCartItems && this._updateItems(cart);
        }

        _toggleView(state) {
            $toggleDisplay(this.$emptyMsg, !state)
            $toggleDisplay(this.$itemsContainer, state)
        }

        _updateItems({ getItems, getSubtotalBlock, getFreeShippingBlock }) {
            this.$subtotalBlock && $replaceContent(this.$subtotalBlock, getSubtotalBlock());
            this.$freeShippingBlock && $replaceContent(this.$freeShippingBlock, getFreeShippingBlock());
            $replaceContent(this.$items, getItems());
        }
    });
})();